import React from "react";
import { skills } from "../content";
import { Code, Layers, Cloud, Spark } from "./Icons";

const iconMap = { code: Code, layers: Layers, cloud: Cloud, spark: Spark };

const Skills = () => (
  <section id="skills" className="section section--sunken section--ruled">
    <div className="shell">
      <div className="section-head">
        <p className="eyebrow">Technical skills</p>
        <h2 className="section-title">What I build with</h2>
        <p className="section-lede">
          Java on the backend, TypeScript on the front, and a growing amount of
          time spent making language models genuinely useful in production.
        </p>
      </div>

      <div className="skills-grid reveal">
        {skills.map(({ icon, title, items }) => {
          const Icon = iconMap[icon];
          return (
            <div className="skill-col" key={title}>
              <span className="skill-icon">
                <Icon />
              </span>
              <h3 className="skill-title">{title}</h3>
              <ul className="skill-list">
                {items.map((item) => (
                  <li className="skill-item" key={item}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Skills;
